"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RenderTask = /** @class */ (function () {
    function RenderTask(pixels, width, height) {
        this.pixels = pixels;
        this.height = height;
        this.width = width;
    }
    return RenderTask;
}());
exports.default = RenderTask;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVuZGVyVGFzay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvUmVuZGVyVGFzay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBO0lBTUUsb0JBQVksTUFBZSxFQUFFLEtBQWEsRUFBRSxNQUFjO1FBQ3hELElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3JCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3JCLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO0lBQ3JCLENBQUM7SUFDSCxpQkFBQztBQUFELENBQUMsQUFYRCxJQVdDIn0=